import { render, staticRenderFns } from "./AmalgamationMetaData.vue?vue&type=template&id=8bd1bd68&scoped=true&"
import script from "./AmalgamationMetaData.vue?vue&type=script&lang=js&"
export * from "./AmalgamationMetaData.vue?vue&type=script&lang=js&"
import style0 from "./AmalgamationMetaData.vue?vue&type=style&index=0&id=8bd1bd68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd1bd68",
  null
  
)

export default component.exports